module.exports = __webpack_public_path__ + "static/media/SF-1.25c8e290.mp3";